import { useDispatch } from 'react-redux';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { Button, ButtonGroup } from '@mui/material';
import {
    Grid,
    Divider,
    Alert
} from '@mui/material';
import { carCaseActionsSaga } from '../../../../infrastructure/services/carCase'




export default function SendCase({ data, state }) {
    const dispatch = useDispatch();

    const handlerChange = (caseId, stateId) => {
        dispatch(carCaseActionsSaga.updateStatus({ caseId, stateId }))
    }

    return (

        <Grid container>
            <Grid xs={12} sm={6} md={6}>
                <Card sx={{ m: 1 }} >
                    <CardHeader
                        title={`Guardar el Juicio N° ${data.caseNumber}`}
                        subheader="Cambio temporal"
                    />
                    <Divider />
                    <CardContent>
                        <Alert severity="success">{ state === 1 ? 'Guarda de manera en temporal, los juicios que ya no esten en Gestión.':'Activar nuevamente el juicio, el juicio estara en Gestión'}</Alert>
                    </CardContent>
                    <Divider />
                    <CardActions>
                        <ButtonGroup fullWidth variant="contained" aria-label="Basic button group">
                            <Button color="success" onClick={() => handlerChange(data.idcase, state === 1 ? 3 : 1)}>{state === 1 ? 'Guardar':'Activar'}</Button>
                        </ButtonGroup>
                    </CardActions>
                </Card>

            </Grid>
            <Grid xs={12} sm={6} md={6}>
                <Card sx={{ m: 1 }}>
                    <CardHeader
                        title={`Guardar el Juicio N° ${data.caseNumber}`}
                        subheader="Cambio permanente"
                    />
                    <Divider />
                    <CardContent>
                        <Alert severity="error">Elimina de forma permanente los juicios, esta accion es irreversible</Alert>
                    </CardContent>
                    <CardActions>
                        <ButtonGroup fullWidth variant="contained" aria-label="Basic button group">
                            <Button color="error" onClick={() => handlerChange(data.idcase, 2)}>Eliminar</Button>
                        </ButtonGroup>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    );
}